module.exports = __webpack_public_path__ + "static/img/42.50e539b5.png";